import { Component } from '@angular/core';

import { of } from 'rxjs';

import {
  BulletComponent,
  CamNotificationDataService,
  ContainerComponent,
  IconComponent,
  ItemComponent,
  ItemInfoComponent,
  NotificationBoxComponent,
  NotificationDto,
  NotificationInlineComponent,
  NotificationTitleComponent,
} from '@camelot/notification';

import { TestIdDirective } from '@camelot/testing-harness';

export const notificationMock = {
  code: 'TaskAssigned',
  context: {},
  date: '2026-01-01T10:00:00Z',
  id: 'notif-1',
  isNew: true,
  level: 0,
  projectId: 'p-1',
  tenantId: 't-1',
  tenantName: 'Tenant',
  userId: 'u-1',
} as unknown as NotificationDto;

const dataServiceMock = {
  computeKey: () => 'all',
  count: { get$: () => of(3) },
  fetchNotifications$: () => of([notificationMock]),
  fetchNumberOfNotifications$: () => of(3),
  isRead$: () => of(true),
  list: { get$: () => of([notificationMock]) },
  markAsRead$: () => of(true),
};

@Component({
    imports: [
        BulletComponent,
        ContainerComponent,
        IconComponent,
        ItemComponent,
        ItemInfoComponent,
        NotificationBoxComponent,
        NotificationInlineComponent,
        NotificationTitleComponent,
        TestIdDirective,
    ],
    providers: [{ provide: CamNotificationDataService, useValue: dataServiceMock }],
    template: `
    <cam-notification-box camTestId="cam-notification-box" />
    <cam-notification-inline camTestId="cam-notification-inline" message="Inline message" />
    <cam-notification-container camTestId="cam-notification-container" />
    <cam-notification-bullet camTestId="cam-notification-bullet" />
    <cam-notification-item camTestId="cam-notification-item" [notification]="this.notification" />
    <cam-notification-item-icon camTestId="cam-notification-item-icon" icon="task" />
    <cam-notification-item-info camTestId="cam-notification-item-info" />
    <cam-notification-item-title camTestId="cam-notification-item-title">title</cam-notification-item-title>
  `
})
export class NotificationCase {
  public notification = notificationMock;
}
